export const Roles = {
    Admin: "Admin",
    Candidate: "Candidate",
    Unauthorized: "Unauthorized",
};
export function isAdmin(user) {
    return user?.role === Roles.Admin;
}
export function isCandidate(user) {
    return user?.role === Roles.Candidate;
}
//# sourceMappingURL=types.js.map